import { QRCodeSVG } from 'qrcode.react';
import { Box, styled, SxProps } from '@mui/material';

interface QRCodeProps {
  value: string;
  sx?: SxProps;
  size?: number;
}

const QRBox = styled(Box)(({ theme }) => ({
  padding: 2,
  margin: '8px',
  display: 'flex',
  justifyContent: 'center'
}));

/**
 * QRコード
 */
export const QRCode = ({ value, sx, size = 225 }: QRCodeProps) => {
  return (
    <QRBox sx={sx}>
      <QRCodeSVG value={value} size={size} />
    </QRBox>
  );
};
